export default __webpack_public_path__ + "media/zurb/img/design-systems/pattern_library-0c72af2fa7a27e151b9996ed8a0468df.png";